export default __webpack_public_path__ + "media/components/Courses/Show/Images/competencies-7a3fa5d6f498e7d4d83021c03db0469f.svg";